'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ModalDialog = require('./ModalDialog.jsx');

var _ModalDialog2 = _interopRequireDefault(_ModalDialog);

var _Menu = require('./Menu.jsx');

var _Menu2 = _interopRequireDefault(_Menu);

var _UserList = require('./UserList.jsx');

var _UserList2 = _interopRequireDefault(_UserList);

var _MealList = require('./MealList.jsx');

var _MealList2 = _interopRequireDefault(_MealList);

var _client = require('../client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoggedInView = function (_React$Component) {
  _inherits(LoggedInView, _React$Component);

  function LoggedInView(props) {
    _classCallCheck(this, LoggedInView);

    var _this = _possibleConstructorReturn(this, (LoggedInView.__proto__ || Object.getPrototypeOf(LoggedInView)).call(this));

    _this.state = {
      user: Object.assign({}, props.user),
      meals: [],
      mode: 'meals'
    };
    _this.updateUser = _this.updateUser.bind(_this);
    _this.updateMeals = _this.updateMeals.bind(_this);
    _this.toggleMode = _this.toggleMode.bind(_this);
    return _this;
  }

  _createClass(LoggedInView, [{
    key: 'toggleMode',
    value: function toggleMode() {
      this.setState({ mode: this.state.mode == 'meals' ? 'users' : 'meals' });
    }
  }, {
    key: 'updateUser',
    value: function updateUser(user) {
      this.setState({
        user: user,
        mode: 'meals'
      });
    }
  }, {
    key: 'updateMeals',
    value: function updateMeals(user) {
      this.setState({
        meals: meals
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var activity = null;
      if (this.state.mode == 'meals') {
        activity = _react2.default.createElement(_MealList2.default, { user: this.state.user,
          currentUser: this.props.user,
          onUpdate: this.updateMeals
        });
      } else {
        activity = _react2.default.createElement(_UserList2.default, { user: this.state.user,
          currentUser: this.props.user,
          updateUser: this.updateUser
        });
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Menu2.default, { mode: this.state.mode,
          user: this.state.user,
          toggleMode: this.toggleMode,
          currentUser: this.props.user,
          updateUser: this.updateUser }),
        activity
      );
    }
  }]);

  return LoggedInView;
}(_react2.default.Component);

exports.default = LoggedInView;


//////////////////
// WEBPACK FOOTER
// ./client/components/LoggedInView.jsx
// module id = 216
// module chunks = 0